define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/state/rootStore",
	"csi/store/Locales",
	"csi/view/ToolbarPlugin",
	"dojo/text!SiteAdmin/templates/pluginLocale.html",

	"csi/widget/FilteringSelect",
], function(declare, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, {localStore, watchStoreProperty}, StoreLocales, ToolbarPlugin, template) {

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin, ToolbarPlugin], {
		// html template for plugin
		templateString: template,

		// connection points
		selectNode: null,

		postCreate: function() {
			// summary: set store for select control
			this.inherited(arguments);

			var w = this.selectNode;
			w.set("store", StoreLocales);
			w.set("value", localStore.editLocale);
			this.addTooltip(w, this.defAction.m_id);

			// refresh view when locale changes
			this.defAction.m_postAction = () => this._postActionLocale();

			this.connect(w, "onChange", "onChangeSelect");
			this.connect(this.getView(), "onContext", "_onContext");

			// subscribe to selected locale so that all views with plugin stay in sync
			this.own(watchStoreProperty(localStore, "editLocale", (attr, oldValue, newValue) => this._onChangeLocale(newValue)));
		},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: actions do not edit, so enable or disable based on if context is present
			this._setDisabled(this.selectNode, !ctx);
		},

		onChangeSelect: function(/*String*/value) {
			// summary: trigger controller for action, but make sure it is not called initially when created
			if (value != localStore.editLocale) {
				localStore.editLocale = value;
				this.onChange(value, this.defAction);
			}
		},

		_getValueAttr: function() {
			// summary: return value of select node
			return this.selectNode.get("value");
		},

		_onChangeLocale: function(/*String*/newLoc) {
			// summary: process change to locale on all other views with same toolbar plugin
			if (newLoc != this.get("value")) {
				this.selectNode.reinitializeValue(newLoc);
				this._postActionLocale();
			}
		},

		_onContext: function(/*Context*/ctx) {
			// summary: set locale as parameter of context
			ctx.locale = localStore.editLocale;
		},

		_postActionLocale: function() {
			// summary: refresh whole view - necessary if Localization view
			this.getView().refreshWidget();
		}
	});
});